(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cpp-eu-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cpp-eu-order')) {
    class CppEuOrder extends HTMLElement {
      static values = null;
      static queue = Promise.resolve();
      static resumedForms = new WeakSet();

      connectedCallback() {
        this.controller = new AbortController();
        this.fields = Array.from(this.querySelectorAll('[data-eu-field]'));
        this.error = this.querySelector('[role="alert"]');
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;
        if (CppEuOrder.values) this.restore(CppEuOrder.values);
        else CppEuOrder.values = this.read();
        const options = { signal: this.controller.signal };
        this.addEventListener('input', () => this.synchronize(), options);
        this.addEventListener('change', () => {
          this.normalize();
          this.synchronize();
          this.persist().catch(() => this.showError());
        }, options);
        document.addEventListener('submit', (event) => this.onSubmit(event), {
          capture: true,
          signal: this.controller.signal
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      read() {
        return Object.fromEntries(this.fields.map((field) => [
          field.name.slice(11, -1),
          field.type === 'checkbox' ? (field.checked ? field.value : '') : field.value
        ]));
      }

      restore(values) {
        this.fields.forEach((field) => {
          const value = values[field.name.slice(11, -1)] || '';
          if (field.type === 'checkbox') field.checked = value === field.value;
          else field.value = value;
        });
      }

      normalize() {
        const company = this.querySelector('[data-eu-field="company"]');
        const email = this.querySelector('[data-eu-field="email"]');
        company.value = company.value.trim();
        email.value = '';
      }

      synchronize() {
        CppEuOrder.values = this.read();
        document.querySelectorAll('cpp-eu-order').forEach((component) => {
          if (component !== this && component.fields) component.restore(CppEuOrder.values);
        });
      }

      persist() {
        const attributes = this.read();
        this.error.hidden = true;
        CppEuOrder.queue = CppEuOrder.queue.catch(() => {}).then(async () => {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) throw new Error('Cart update failed');
          const result = await response.json();
          if (result.status || !result.attributes) throw new Error('Cart update failed');
        });
        return CppEuOrder.queue;
      }

      showError() {
        this.error.textContent = this.dataset.saveError;
        this.error.hidden = false;
      }

      async onSubmit(event) {
        const form = event.target;
        const ownForm = form === this.form;
        const spareSeal = form.matches('.cpp-spare-seal__form') &&
          document.querySelector('cpp-eu-order') === this;
        if (!ownForm && !spareSeal) return;
        if (CppEuOrder.resumedForms.has(form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy) return;
        this.normalize();
        this.synchronize();
        const submitter = event.submitter;
        if (ownForm && submitter?.name === 'checkout') {
          for (const field of this.fields) {
            if (!field.reportValidity()) return;
          }
        }
        this.busy = true;
        try {
          await this.persist();
          CppEuOrder.resumedForms.add(form);
          form.requestSubmit(submitter || undefined);
          CppEuOrder.resumedForms.delete(form);
        } catch {
          this.showError();
        } finally {
          this.busy = false;
        }
      }
    }
    customElements.define('cpp-eu-order', CppEuOrder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cpp-free-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cpp-row-free-delivery')) {
    customElements.define('cpp-row-free-delivery', class extends HTMLElement {
      connectedCallback() {
        const baseThreshold = Number(this.dataset.baseThreshold);
        const total = Number(this.dataset.cartTotal);
        const currency = this.dataset.currency;
        if (this.dataset.shopCurrency !== 'GBP' || !Number.isFinite(baseThreshold) || baseThreshold <= 0 || !Number.isFinite(total) || total < 0) return;
        const converted = currency !== 'GBP';
        const currencySettings = window.Shopify?.currency;
        const rate = converted ? Number(currencySettings?.rate) : 1;
        if (converted && (currencySettings?.active !== currency || !Number.isFinite(rate) || rate <= 0)) return;
        const threshold = Math.ceil(baseThreshold * rate);
        if (!Number.isSafeInteger(threshold) || threshold <= 0) return;
        let formatter;
        try {
          formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code' });
        } catch {
          return;
        }
        const amount = value => formatter.format(value / 100);
        const remaining = Math.max(0, threshold - total);
        this.querySelector('[data-row-threshold]').textContent = (converted ? this.dataset.estimateLabel : this.dataset.thresholdLabel).replace('[amount]', amount(threshold));
        const message = this.querySelector('[data-row-remaining]');
        message.textContent = remaining > 0
          ? (converted ? this.dataset.remainingEstimateLabel : this.dataset.remainingLabel).replace('[amount]', amount(remaining))
          : (converted ? this.dataset.reachedEstimateLabel : this.dataset.reachedLabel);
        message.hidden = false;
        this.querySelector('[data-row-track]').hidden = false;
        this.querySelector('[data-row-note]').textContent = converted ? this.dataset.estimateNote : this.dataset.note;
        this.style.setProperty('--cpp-delivery-progress', String(Math.min(100, Math.max(0, total / threshold * 100))) + '%');
        this.classList.toggle('cpp-free-delivery--reached', remaining === 0);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cpp-international-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cpp-international-order')) {
    class CppInternationalOrder extends HTMLElement {
      static state = new Map();
      static queue = Promise.resolve();
      static resumed = new WeakSet();

      connectedCallback() {
        this.controller = new AbortController();
        this.cartForm = document.getElementById(this.dataset.formId);
        this.company = this.querySelector('[data-company]');
        this.taxType = this.querySelector('[data-tax-type]');
        this.taxNumber = this.querySelector('[data-tax-number]');
        this.consent = this.querySelector('[data-consent]');
        this.consentTime = this.querySelector('[data-consent-time]');
        this.checkoutCountry = this.querySelector('[data-checkout-country]');
        this.country = this.querySelector('[data-country-select]');
        this.countryAttribute = this.querySelector('[data-country-attribute]');
        this.error = this.querySelector('[data-order-error]');
        this.quoteForm = this.querySelector('.cpp-international-order__quote');
        this.quoteError = this.querySelector('[data-quote-error]');
        this.preview = this.dataset.preview === 'true';
        this.stateKey = `${this.preview ? 'preview:' : ''}${this.dataset.country}`;
        const previous = CppInternationalOrder.state.get(this.stateKey);
        if (previous) {
          this.company.value = previous.company;
          this.taxType.value = previous.taxType || '';
          this.taxNumber.value = previous.taxNumber || '';
          this.consent.checked = previous.confirmed;
          this.consentTime.value = previous.recordedAt;
        }
        this.remember();
        const options = { signal: this.controller.signal };
        this.company.addEventListener('input', () => {
          const wasConfirmed = this.consent.checked;
          this.consent.checked = false;
          this.consentTime.value = '';
          this.remember();
          if (wasConfirmed) this.persist(false).catch(() => this.showError());
        }, options);
        this.company.addEventListener('change', () => this.persist().catch(() => this.showError()), options);
        for (const field of [this.taxType, this.taxNumber]) {
          field.addEventListener('input', () => this.remember(), options);
          field.addEventListener('change', () => this.persist().catch(() => this.showError()), options);
        }
        this.consent.addEventListener('change', () => {
          this.consentTime.value = this.consent.checked ? new Date().toISOString() : '';
          this.remember();
          this.persist().catch(() => this.showError());
        }, options);
        this.country.addEventListener('change', () => this.changeCountry(), options);
        document.addEventListener('submit', event => this.onSubmit(event), { ...options, capture: true });
        this.querySelector('[data-quote-button]').disabled = false;
        if (!previous && !this.preview) this.persist().catch(() => this.showError());
      }

      disconnectedCallback() { this.controller?.abort(); }

      remember() {
        CppInternationalOrder.state.set(this.stateKey, {
          company: this.company.value,
          taxType: this.taxType.value,
          taxNumber: this.taxNumber.value,
          confirmed: this.consent.checked,
          recordedAt: this.consentTime.value
        });
        this.checkoutCountry.value = this.checkoutCountryValue();
      }

      checkoutCountryValue() {
        return this.company.value.trim() && this.consent.checked && this.consent.value && this.consentTime.value
          ? this.dataset.country : '';
      }

      attributes() {
        return {
          'International business name': this.company.value.trim(),
          'International business tax type': this.taxType.value.trim(),
          'International business tax number': this.taxNumber.value.trim(),
          'International delivery country': this.dataset.country,
          'International business and import charges confirmation': this.consent.checked ? this.consent.value : '',
          'International confirmation recorded at': this.consent.checked ? this.consentTime.value : '',
          'International checkout approval country': this.checkoutCountryValue()
        };
      }

      persist(trimCompany = true) {
        if (trimCompany) this.company.value = this.company.value.trim();
        this.taxType.value = this.taxType.value.trim();
        this.taxNumber.value = this.taxNumber.value.trim();
        this.remember();
        if (this.preview) return Promise.resolve();
        const attributes = this.attributes();
        this.error.hidden = true;
        CppInternationalOrder.queue = CppInternationalOrder.queue.catch(() => {}).then(async () => {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) throw new Error('Cart update failed');
          const result = await response.json();
          if (result.status || !result.attributes) throw new Error('Cart update failed');
          for (const [key, value] of Object.entries(attributes)) {
            if ((result.attributes[key] || '') !== value) throw new Error('Cart attributes were not saved');
          }
        });
        return CppInternationalOrder.queue;
      }

      showError(message = this.dataset.saveError) {
        this.error.textContent = message;
        this.error.hidden = false;
      }

      async changeCountry() {
        this.taxType.value = '';
        this.taxNumber.value = '';
        this.consent.checked = false;
        this.consentTime.value = '';
        this.remember();
        if (this.preview) {
          this.dataset.country = this.country.value;
          this.dataset.countryName = this.country.selectedOptions[0].textContent;
          this.countryAttribute.value = this.country.value;
          this.stateKey = `preview:${this.country.value}`;
          this.querySelector('[data-florida]').hidden = !['CA', 'MX'].includes(this.country.value);
          this.querySelector('[data-quote-details]').open = false;
          this.error.hidden = true;
          this.quoteError.hidden = true;
          return;
        }
        try {
          await this.persist();
          this.country.form.requestSubmit();
        } catch {
          this.country.value = this.dataset.country;
          this.showError();
        }
      }

      async onSubmit(event) {
        const form = event.target;
        const checkout = form === this.cartForm && event.submitter?.name === 'checkout';
        const quote = form === this.quoteForm;
        if (!checkout && !quote || CppInternationalOrder.resumed.has(form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy) return;
        this.company.value = this.company.value.trim();
        if (!this.company.reportValidity()) return;
        if (checkout && !this.consent.reportValidity()) return;
        if (this.preview) { this.showError(this.dataset.previewMessage); return; }
        this.busy = true;
        try {
          if (quote) {
            if (!['CA', 'MX'].includes(this.dataset.country)) throw new Error('Quote destination unavailable');
            this.quoteError.hidden = true;
            const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Basket could not be read');
            const cart = await response.json();
            if (!cart.items?.length) throw new Error('Basket is empty');
            this.querySelector('[data-quote-company]').value = this.company.value;
            this.querySelector('[data-quote-tax-type]').value = this.taxType.value.trim();
            this.querySelector('[data-quote-tax-number]').value = this.taxNumber.value.trim();
            this.querySelector('[data-quote-country]').value = this.dataset.countryName;
            this.querySelector('[data-quote-body]').value = [
              this.dataset.quoteHeading,
              ...cart.items.map(item => `${item.product_title || item.title}${item.variant_title && item.variant_title !== 'Default Title' ? ` / ${item.variant_title}` : ''}\n${this.dataset.skuLabel}: ${item.sku || item.variant_id}\n${this.dataset.quantityLabel}: ${item.quantity}`)
            ].join('\n\n');
          } else {
            if (!this.consentTime.value) this.consentTime.value = new Date().toISOString();
            await this.persist();
          }
          CppInternationalOrder.resumed.add(form);
          try { form.requestSubmit(event.submitter || undefined); }
          finally { CppInternationalOrder.resumed.delete(form); }
        } catch {
          if (quote) {
            this.quoteError.textContent = this.dataset.quoteError;
            this.quoteError.hidden = false;
          } else this.showError();
        } finally { this.busy = false; }
      }
    }
    customElements.define('cpp-international-order', CppInternationalOrder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cpp-policy-page"] && !Shopify.designMode) return;
  try {
    function initializeCppPolicyPages() {
    document.querySelectorAll('[data-cpp-policy-page]').forEach((page) => {
      if (page.dataset.cppPolicyReady) return;
      page.dataset.cppPolicyReady = 'true';
      const contact = page.querySelector('#cpp-contact-information');
      if (contact) {
        contact.querySelectorAll('a').forEach((link) => {
          const href = link.getAttribute('href') || '';
          if (href && !href.startsWith('file:')) return;
          const text = link.textContent.trim().toLowerCase();
          if (text === 'send an enquiry') link.setAttribute('href', page.dataset.contactUrl);
          if (text === 'refund policy' && page.dataset.refundUrl) link.setAttribute('href', page.dataset.refundUrl);
        });
      }
      page.querySelectorAll('.shopify-policy__body p').forEach((source) => {
        if (!source.querySelector('br') || (source.textContent.match(/SECTION \d+ - /g) || []).length < 4) return;
        const lines = [[]];
        source.childNodes.forEach((node) => {
          if (node.nodeName === 'BR') lines.push([]);
          else lines[lines.length - 1].push(node.cloneNode(true));
        });
        const output = document.createDocumentFragment();
        let paragraph = null;
        const flush = () => {
          if (paragraph && paragraph.textContent.trim()) output.appendChild(paragraph);
          paragraph = null;
        };
        lines.forEach((nodes) => {
          const text = nodes.map((node) => node.textContent).join('').trim();
          if (!text) { flush(); return; }
          if (text === '----') {
            flush();
            const divider = document.createElement('hr');
            divider.className = 'cpp-policy-divider';
            output.appendChild(divider);
            return;
          }
          if (text === 'OVERVIEW' || /^SECTION \d+ - /.test(text)) {
            flush();
            const heading = document.createElement('h2');
            nodes.forEach((node) => heading.appendChild(node));
            output.appendChild(heading);
            return;
          }
          if (text === 'TERMS OF SERVICE') {
            flush();
            const title = document.createElement('p');
            title.className = 'cpp-policy-document-title';
            nodes.forEach((node) => title.appendChild(node));
            output.appendChild(title);
            return;
          }
          if (!paragraph) paragraph = document.createElement('p');
          if (paragraph.childNodes.length) paragraph.appendChild(document.createTextNode(' '));
          nodes.forEach((node) => paragraph.appendChild(node));
          if (/[.!?]$/.test(text)) flush();
        });
        flush();
        source.replaceWith(output);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCppPolicyPages);
  else initializeCppPolicyPages();
  document.addEventListener('shopify:section:load', initializeCppPolicyPages);
  } catch(e) { console.error(e); }
})();

})();
